/**
 * Firestore: merchants/{merchantId}/flash_deals/{dealId}
 * Fields: merchantId, merchantName, itemName, dealText, photoUrl,
 * durationDays, createdAt, expiresAt (camelCase).
 */
import { addDoc, collection, serverTimestamp, Timestamp } from "firebase/firestore";
import { firebaseDb } from "../firebase/firebaseClient";

export const FLASH_DEAL_DURATION_OPTIONS = [1, 3, 7, 14, 30];

export async function createFlashDeal(merchantId, merchantName, { itemName, dealText, durationDays, photoUrl }) {
  const mid = String(merchantId || "").trim();
  const name = String(merchantName || "").trim();
  const item = String(itemName || "").trim();
  const deal = String(dealText || "").trim();
  const days = Number(durationDays);

  if (!mid) throw new Error("createFlashDeal: merchantId is required");
  if (!item) throw new Error("createFlashDeal: itemName is required");
  if (!deal) throw new Error("createFlashDeal: dealText is required");
  if (!FLASH_DEAL_DURATION_OPTIONS.includes(days)) {
    throw new Error("createFlashDeal: durationDays must be one of FLASH_DEAL_DURATION_OPTIONS");
  }

  const payload = {
    merchantId: mid,
    merchantName: name,
    itemName: item,
    dealText: deal,
    photoUrl: photoUrl || null,
    durationDays: days,
    createdAt: serverTimestamp(),
    expiresAt: Timestamp.fromMillis(Date.now() + days * 24 * 60 * 60 * 1000),
  };

  await addDoc(collection(firebaseDb, "merchants", mid, "flash_deals"), payload);
}
